import ShareableLinkMain from './ShareableLinkMain.page';

export default ShareableLinkMain;
